import React, { Component } from 'react';
import { Checkbox, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { apiInterfaceForJson } from '../../../../services/common/apiManager';

export default class ObjectIdRefMultiField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            loading: false
        };
    }

    componentDidMount() {
        this.loadOptions();
    }

    loadOptions = () => {
        const { fieldDef } = this.props;
        if (!fieldDef.dataSource || !fieldDef.dataSource.endpoint) {
            return;
        }

        this.setState({ loading: true });
        const method = fieldDef.dataSource.method || 'GET';
        const params = fieldDef.dataSource.params || undefined;
        apiInterfaceForJson(fieldDef.dataSource.endpoint, method, params)
            .then((response) => {
                const data = response.data || [];
                const labelField = fieldDef.dataSource.labelField || 'name';
                const valueField = fieldDef.dataSource.valueField || '_id';
                const options = data.map((item) => ({
                    label: item[labelField],
                    value: item[valueField]
                }));
                this.setState({ options, loading: false });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    };

    handleChange = (e) => {
        const { fieldDef, onChange } = this.props;
        const selected = e.target.value;
        const includeSelectAll = fieldDef.dataSource && fieldDef.dataSource.includeSelectAll;

        if (includeSelectAll && selected.includes('all')) {
            const currentValue = this.props.value || [];
            const allValues = this.state.options.map((opt) => opt.value);
            if (currentValue.length === allValues.length) {
                onChange(fieldDef.fieldId, []);
            } else {
                onChange(fieldDef.fieldId, allValues);
            }
        } else {
            onChange(fieldDef.fieldId, selected);
        }
    };

    render() {
        const { fieldDef, value, hasError, errorMessage, disabled } = this.props;
        const isRequired = fieldDef.validation && fieldDef.validation.required;
        const selected = value || [];
        const options = this.state.options;
        const includeSelectAll = fieldDef.dataSource && fieldDef.dataSource.includeSelectAll;
        const isAllSelected = options.length > 0 && selected.length === options.length;

        return (
            <div className="form-group">
                <label>
                    {fieldDef.label}
                    {isRequired && <span className="text-danger"> *</span>}
                </label>
                <FormControl variant="outlined" style={{ width: '100%', marginTop: '5px' }}>
                    <InputLabel id={fieldDef.fieldId + '-label'}>{fieldDef.placeholder || fieldDef.label}</InputLabel>
                    {!this.state.loading && (
                        <Select
                            labelId={fieldDef.fieldId + '-label'}
                            id={fieldDef.fieldId + '-select'}
                            value={selected}
                            onChange={this.handleChange}
                            label={fieldDef.placeholder || fieldDef.label}
                            name={fieldDef.fieldId}
                            multiple
                            disabled={disabled}
                            renderValue={(sel) => {
                                if (isAllSelected) {
                                    return 'All Selected';
                                }
                                const labels = [];
                                options.forEach((opt) => {
                                    if (sel.includes(opt.value)) {
                                        labels.push(opt.label);
                                    }
                                });
                                return labels.join(', ');
                            }}
                        >
                            {includeSelectAll && (
                                <MenuItem
                                    className={isAllSelected ? 'Mui-selected' : ''}
                                    key="all"
                                    value="all"
                                >
                                    <Checkbox checked={isAllSelected} />
                                    Select All
                                </MenuItem>
                            )}
                            {options.map((opt) => (
                                <MenuItem key={opt.value} value={opt.value}>
                                    <Checkbox checked={selected.includes(opt.value)} />
                                    {opt.label}
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                </FormControl>
                <div className={hasError ? 'inline-errormsg' : 'hidden'}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true">
                        &nbsp;{errorMessage || 'This field is required.'}
                    </i>
                </div>
            </div>
        );
    }
}
